module.exports = __webpack_public_path__ + "img/2_269.32c76da7.png";